<template>
  <v-main v-if="showAdminDashboard">
    <v-container fluid class="pa-6">
      <admin-dashboard />
    </v-container>
  </v-main>

  <shortcuts-page v-else />
</template>

<script>
import AdminDashboard from "./dashboard/AdminDashboard.vue";
import ShortcutsPage from "./shortcuts.vue";

export default {
  name: "HomePage",
  components: { AdminDashboard, ShortcutsPage },
  computed: {
    // Franchise performance overview: admins see every zone, a master
    // franchisee only their own zone, a franchisee admin only their own
    // franchise (the API enforces this). Everyone else lands on the shortcut tiles.
    showAdminDashboard() {
      return (
        this.company.id != null &&
        this.visible_to([
          "ADMIN",
          "SUPER ADMIN",
          "BACKEND ADMIN",
          "MASTER FRANCHISEE",
          "FRANCHISEE ADMIN",
        ])
      );
    },
  },
};
</script>
